module.exports = __webpack_public_path__ + "static/media/bha_chandrabindu.24ea8845.ogg";